export default Object.freeze({
    POSITION_NAME_MAX_LEN: 256, //役職名 最大桁数
    POSITION_NUMBER_MIN_VAL: 0, //役職優位番号 最小値
    POSITION_NUMBER_MAX_VAL: 999 //役職優位番号 最大値
  });